import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const getCulturesCatalog = state => state.models[name].cultures;
export const getCurCulture = state => state.models[name].culture;
